import {
  CLEAR_RESULTS,
  GLOBAL_SEARCH,
  GLOBAL_SEARCH_FAILED,
  GLOBAL_SEARCH_SUCCEEDED,
} from 'Redux/Types/GlobalSearchTypes'

const INITIAL_STATE = {
  results: [],
  searching: false,
}

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case CLEAR_RESULTS:
      return INITIAL_STATE

    case GLOBAL_SEARCH:
      return {
        ...state,
        searching: true,
      }

    case GLOBAL_SEARCH_FAILED:
      return {
        ...state,
        searching: false,
      }

    case GLOBAL_SEARCH_SUCCEEDED:
      return {
        ...state,
        next: payload.next?.split('/documents/search?')[1],
        results: payload.fetchMore ? [...state.results, ...payload.data] : payload.data,
        searching: false,
      }

    default:
      return state
  }
}
